module.exports = __webpack_public_path__ + "img/no-data.451fdc5e.png";